let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dnBLN")).then(() => parcelRequire('7lB9m'));